import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useRef, useState } from 'react';
import { Icon } from '@livable/saas-react-components';
import { TAG_COLORS } from 'src/constants/tag';
import { observer } from 'mobx-react-lite';
import { useStore } from 'src/stores';
import useStyles from './styles';
export const TagModalChip = observer(_ref => {
  let data = _ref.data,
    handleDelete = _ref.handleDelete;
  const store = useStore();
  const classes = useStyles();
  const wrapperRef = useRef(null);
  const colorIdx = TAG_COLORS.findIndex(i => i === data.color);
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showColors = _useState2[0],
    setShowColors = _useState2[1];
  const _useState3 = useState(colorIdx > -1 ? TAG_COLORS[colorIdx] : TAG_COLORS[0]),
    _useState4 = _slicedToArray(_useState3, 2),
    currentColor = _useState4[0],
    setCurrentColor = _useState4[1];
  const handleChange = async newColor => {
    await store.tags.updateTagAsync.run({
      tagId: data.id,
      name: data.name,
      color: newColor
    });
  };
  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setShowColors(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [wrapperRef]);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.tagChip
  }, data.isEditable && /*#__PURE__*/React.createElement("div", {
    className: classes.tagChipAction,
    style: {
      backgroundColor: currentColor
    },
    onBlur: () => setShowColors(!showColors),
    onClick: () => setShowColors(!showColors)
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "triangle-down"
  }), showColors && /*#__PURE__*/React.createElement("div", {
    className: classes.colors,
    ref: wrapperRef
  }, TAG_COLORS.map((i, k) => /*#__PURE__*/React.createElement("div", {
    className: classes.color,
    style: {
      backgroundColor: TAG_COLORS[k]
    },
    onClick: () => {
      setCurrentColor(TAG_COLORS[k]);
      handleChange(TAG_COLORS[k]);
    }
  })))), /*#__PURE__*/React.createElement("div", {
    className: classes.tagChipTitle,
    style: {
      backgroundColor: currentColor
    }
  }, data.name), /*#__PURE__*/React.createElement("div", {
    className: classes.tagChipDelete,
    style: {
      backgroundColor: currentColor
    },
    onClick: () => {
      handleDelete(data.id, data.isEditable);
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "close"
  })));
});